import Stack from '@mui/material/Stack'
import { type ReactElement } from 'react'
import type { TripData } from 'screens/TripDashboard/TripDashboard.types'
import type { LegData } from 'screens/TripDetails/TripDetails.types'
import LegCard from './LegCard'

export interface ShipmentsViewProps {
  trip: TripData
  legs: LegData[]
  weblinkToken?: string
}

const ShipmentsView = ({ trip, legs, weblinkToken }: ShipmentsViewProps): ReactElement => (
  <Stack spacing={2} sx={{ flexGrow: 1 }}>
    {legs.map((leg) => (
      <LegCard key={leg.shipmentNumber} trip={trip} leg={leg} weblinkToken={weblinkToken} />
    ))}
  </Stack>
)

export default ShipmentsView
